import React, { useContext } from 'react';
import { SearchContext } from '../../../context/search-context';

export default function Search({ className, onClick: onElmClick, mode = 'button', ...props }) {
  const { handleOpenModal } = useContext(SearchContext);

  if (mode === 'item') {
    return (
      <li
        className={className}
        onClick={() => {
          handleOpenModal();
          if (onElmClick) onElmClick();
        }}
        {...props}
      >
        <span className="item-text">
          <svg
            width="12"
            height="12"
            viewBox="0 0 22 22"
            fill="#565656"
            xmlns="http://www.w3.org/2000/svg"
            className={'ml-6p'}
          >
            <path d="M21.6355 19.9093L17.4977 15.7716C19.023 13.8075 19.7424 11.3358 19.5094 8.85989C19.2764 6.38398 18.1085 4.08993 16.2435 2.44479C14.3785 0.799654 11.9566 -0.0728988 9.47086 0.00477402C6.98513 0.0824469 4.62243 1.10451 2.86379 2.86287C1.10515 4.62124 0.0827789 6.98373 0.00481028 9.46936C-0.0731584 11.955 0.799141 14.3769 2.44412 16.242C4.0891 18.1072 6.38309 19.2753 8.85907 19.5086C11.335 19.7419 13.8069 19.0228 15.7713 17.4978L19.9092 21.6354C20.0222 21.7503 20.1569 21.8416 20.3053 21.9042C20.4538 21.9668 20.6132 21.9993 20.7744 22C20.9355 22.0006 21.0952 21.9694 21.2442 21.908C21.3932 21.8467 21.5285 21.7564 21.6425 21.6425C21.7564 21.5286 21.8467 21.3932 21.908 21.2442C21.9694 21.0952 22.0006 20.9356 22 20.7744C21.9993 20.6133 21.9668 20.4539 21.9042 20.3054C21.8416 20.1569 21.7503 20.0223 21.6354 19.9093H21.6355ZM2.46316 9.7868C2.46316 8.33832 2.8927 6.92237 3.69746 5.71801C4.50222 4.51364 5.64606 3.57495 6.98433 3.02064C8.3226 2.46633 9.79519 2.3213 11.2159 2.60388C12.6366 2.88647 13.9416 3.58398 14.9659 4.60821C15.9901 5.63244 16.6877 6.93739 16.9702 8.35803C17.2528 9.77868 17.1078 11.2512 16.5535 12.5894C15.9991 13.9277 15.0604 15.0715 13.856 15.8762C12.6516 16.6809 11.2356 17.1104 9.78707 17.1104C7.84531 17.1083 5.98372 16.336 4.61069 14.963C3.23766 13.59 2.46534 11.7285 2.46316 9.7868Z" />
          </svg>
          جستجو
        </span>
      </li>
    );
  }

  return (
    <>
      <div className={className}>
        <button
          className={'btn br-c-p w-100 bc-b-c d-flex align-items-center justify-content-center'}
          type="button"
          onClick={handleOpenModal}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 22 22"
            fill="#565656"
            xmlns="http://www.w3.org/2000/svg"
            className={'ml-6p'}
          >
            <path d="M21.6355 19.9093L17.4977 15.7716C19.023 13.8075 19.7424 11.3358 19.5094 8.85989C19.2764 6.38398 18.1085 4.08993 16.2435 2.44479C14.3785 0.799654 11.9566 -0.0728988 9.47086 0.00477402C6.98513 0.0824469 4.62243 1.10451 2.86379 2.86287C1.10515 4.62124 0.0827789 6.98373 0.00481028 9.46936C-0.0731584 11.955 0.799141 14.3769 2.44412 16.242C4.0891 18.1072 6.38309 19.2753 8.85907 19.5086C11.335 19.7419 13.8069 19.0228 15.7713 17.4978L19.9092 21.6354C20.0222 21.7503 20.1569 21.8416 20.3053 21.9042C20.4538 21.9668 20.6132 21.9993 20.7744 22C20.9355 22.0006 21.0952 21.9694 21.2442 21.908C21.3932 21.8467 21.5285 21.7564 21.6425 21.6425C21.7564 21.5286 21.8467 21.3932 21.908 21.2442C21.9694 21.0952 22.0006 20.9356 22 20.7744C21.9993 20.6133 21.9668 20.4539 21.9042 20.3054C21.8416 20.1569 21.7503 20.0223 21.6354 19.9093H21.6355ZM2.46316 9.7868C2.46316 8.33832 2.8927 6.92237 3.69746 5.71801C4.50222 4.51364 5.64606 3.57495 6.98433 3.02064C8.3226 2.46633 9.79519 2.3213 11.2159 2.60388C12.6366 2.88647 13.9416 3.58398 14.9659 4.60821C15.9901 5.63244 16.6877 6.93739 16.9702 8.35803C17.2528 9.77868 17.1078 11.2512 16.5535 12.5894C15.9991 13.9277 15.0604 15.0715 13.856 15.8762C12.6516 16.6809 11.2356 17.1104 9.78707 17.1104C7.84531 17.1083 5.98372 16.336 4.61069 14.963C3.23766 13.59 2.46534 11.7285 2.46316 9.7868Z" />
          </svg>
          جستجو
        </button>
      </div>
    </>
  );
}
